import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { Container, Modal, Typography } from '@material-ui/core';
import { setChapterIndex, setParagraphIndex } from '../../../utils/storage';
import ActionButton from '../../../components/ActionButton';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    borderRadius: '6px',
    boxShadow: theme.shadows[6],
    overflowY: 'auto',
    padding: theme.spacing(3),
    gap: theme.spacing(4),
    maxWidth: '560px',
  },
}));

export default function GoToPageModal(props) {
  const history = useHistory();
  const classes = useStyles();

  const goto = () => {
    setChapterIndex(0);
    setParagraphIndex(0);
    history.push(props.path);
  };

  return (
    <Modal open={props.open} onClose={props.onCancel} className={classes.modal}>
      <div className={classes.modalContainer}>
        <Typography variant="h5">
          Operazione completata con successo.
        </Typography>
        <Typography variant="h6">{props.message}</Typography>
        <Container>
          <ActionButton
            secondaryButton
            label="Chiudi"
            disabled={false}
            onClick={props.onCancel}
            grayVersion={false}
          />
          <ActionButton
            label="Avanti"
            disabled={false}
            onClick={() => {
              goto();
            }}
            grayVersion={false}
          />
        </Container>
      </div>
    </Modal>
  );
}

GoToPageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
};
